/**
 * Provider user agreements are xpath-documents documents (XPT-12272). This
 * rebuilds the row the agreement tables render.
 */
export interface UserAgreementRow {
  id: number;
  name: string;
  user_name: string;
  status: "uploaded" | "archived";
  file: string | null;
  entity_id: number;
  created_at: string;
}

export function mapUserAgreement(document: any): UserAgreementRow {
  return {
    id: document.id,
    name: document.name,
    user_name: document.created_by?.text ?? "",
    status: document.status_id === 2 ? "archived" : "uploaded",
    file: document.files?.[0]?.file_path ?? null,
    entity_id: document.entity_id,
    created_at: document.created_at,
  };
}
